import React from 'react';
import withView from '../../../cmn/docAutomation/withView';
import SarasTrans from '../../../../library/notifications/SarasTrans';
import ItemQVSalesRow from './ItemQVSalesRow';
import { UiViewContent, UiView } from "../../../../library/layout/Index";

const ItemQVSales = (props) => {
    const { formObject, viewData } = props;

    return (
        <>
        <UiView>
            <UiViewContent>
                <ul className="uiListTable" style={{backgroundColor:"#FFF", width:"max-content"}}>
                    <li className="uiSearchHeading">
                        <ul>
                            <li className="uiColumnCenter uiColumn90"><SarasTrans value="Order Date" /></li>
                            <li className="uiColumnCenter uiColumn170"><SarasTrans value="Customer Name" /></li>
                            <li className="uiColumnCenter uiColumn70"><SarasTrans value="Quantity" /></li>
                            <li className="uiColumnCenter uiColumn70"><SarasTrans value="Unit Price" /></li>
                        </ul>
                    </li>
                    {
                        Object.values(viewData ? viewData : {}).map((row, index) => (
                            <li><ItemQVSalesRow formObject={formObject} rowKey={row.rowKey} viewData={row} key={index} index={index + 1} /></li>
                        ))
                    }
                </ul>
            </UiViewContent>
        </UiView>
        </>
    )
}

export default withView(ItemQVSales, "","");